import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { useUserParams } from "../hooks/useUserParams";

export default function InquiryCard() {
  const { getCurrentAgentNumber, getCurrentAgentEmail } = useUserParams();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    setLoading(true);

    try {
      // Add your API call here

      console.log(formData);

      setFormData({
        name: "",
        email: "",
        message: "",
      });

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="rounded-3xl bg-white shadow-xl p-8">

      <div className="flex items-center gap-3 mb-6">
        <div className="h-12 w-12 rounded-full bg-summit-highlight/20 flex items-center justify-center">
          <FontAwesomeIcon
            icon={faEnvelope}
            className="text-summit-highlight text-xl"
          />
        </div>

        <div>
          <h3 className="text-xl font-semibold text-summit-primary">
            Inquire About This Property
          </h3>
          <p className="text-sm text-slate-500">
            Get more details from our agent
          </p>
        </div>
      </div>


      <form
        onSubmit={handleSubmit}
        className="space-y-4"
      >

        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Full Name"
          className="w-full rounded-xl border border-slate-200 px-4 py-3 outline-none focus:border-summit-highlight"
        />


        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email Address"
          className="w-full rounded-xl border border-slate-200 px-4 py-3 outline-none focus:border-summit-highlight"
        />


        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          rows="4"
          placeholder="I am interested in this property..."
          className="w-full resize-none rounded-xl border border-slate-200 px-4 py-3 outline-none focus:border-summit-highlight"
        />


        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-xl bg-summit-primary py-3 text-white flex items-center justify-center gap-2 transition hover:bg-summit-highlight disabled:opacity-50"
        >
          <FontAwesomeIcon icon={faPaperPlane} />
          {loading ? "Sending..." : "Send Inquiry"}
        </button>

      </form>


      <div className="mt-6 border-t pt-5 text-sm text-slate-500 text-center">
        <p>
          Contact directly:
        </p>

        <p className="mt-2 font-medium text-summit-primary">
          {getCurrentAgentNumber()}
        </p>

        <p>
          {getCurrentAgentEmail()}
        </p>
      </div>

    </div>
  );
}